/** 药品分类的图标 */
export const defaultCategryIcons = {
  '呼吸系统用药': 'img0',
  '清热、消炎': 'img1',
  '五官、皮肤及外用': 'img2',
  '消化、肝胆系统': 'img3',
  '补益安神及维矿类': 'img4',
  '妇、儿科': 'img5',
  '心脑血管及神经类用药': 'img6',
  '内分泌系统（含糖尿病）': 'img7',
  '风湿骨伤及其他药品': 'img8',
  '特殊复方制剂、生物制品': 'img9',
  '医疗器械': 'img10',
  '非药品': 'img11',
  '中药饮片': 'img12',

}



// WEBPACK FOOTER //
// ./src/components/nav/categoryIcons.js